/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Col, Container, Row} from "react-bootstrap";
import React, {Fragment} from "react";
import {Glyphicon} from "../GlyphIcon";

export const FileDraggingOverlay = (props) => {
    const { contextNode, show } = props;
    
    if(!show) {
        return null;
    }
    
    return <Container>
        <div className="sb-filedrag-hover"/>
        <div className="sb-filedrag-hover-overlay-popup">
            <Row>
                <Col xs={12}>
                    {contextNode?.title ?
                        <Fragment>
                            <h3>Drop File(s) to upload to</h3>
                            <h3>{contextNode.title}</h3>
                        </Fragment>
                        :
                        <h2>Drop File(s) to upload.</h2>
                    }
                </Col>
            </Row>
            <Row className="top30">
                <Col xs={12}>
                    <Glyphicon glyph="cloud-upload"/>
                </Col>
            </Row>
        </div>
    </Container>
}
